import { render } from "./CustomerOrdersListPage.vue?vue&type=template&id=15bec204&scoped=true"
import script from "./CustomerOrdersListPage.vue?vue&type=script&lang=js"
export * from "./CustomerOrdersListPage.vue?vue&type=script&lang=js"

import "./CustomerOrdersListPage.vue?vue&type=style&index=0&id=15bec204&scoped=true&lang=scss"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15bec204"]])

export default __exports__